module.exports = __webpack_public_path__ + "img/location_icon.c350e9b5.svg";